import { useTheme } from '@mui/styles';

import {
  CELL_SPACING,
  CELL_WIDTH,
  HEADER_DAY_HEIGHT,
} from '~/scenes/MyWorkspace/components/Widgets/components/MyTeamAbsencesWidget/constants';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    navigationWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignContent: 'center',
      justifyContent: 'space-between',
      fontWeight: 'bold',
    },
    dayCells: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      height: `${HEADER_DAY_HEIGHT}px`,
      lineHeight: 1.3,
      fontWeight: 'bold',
    },
    dayCell: {
      width: `${CELL_WIDTH}px`,
      textAlign: 'center',
      borderRadius: `${theme.shape.borderRadius + 1}px`,
      marginRight: `${CELL_SPACING}px`,
      flexShrink: 0,
    },
    startEndDates: {
      overflow: 'hidden',
      alignSelf: 'center',
      display: 'flex',
    },
  };
};
